module.exports = "https://bin.bnbstatic.com/_next/static/images/warn-ddc1bdc7afef8754a1c656dc8e8f5ce8.svg";